export default __webpack_public_path__ + "static/media/Lipids.ebff8d6b.svg";